import Router from "next/router"
import NProgress from "nprogress"
import { Analytics } from "@vercel/analytics/next"
import { AppProvider } from "@/lib/contexts/appContext"
import "../styles/app.css"

NProgress.configure({
  showSpinner: false // Set to false if you want to disable the spinner
})

Router.events.on("routeChangeStart", () => NProgress.start())
Router.events.on("routeChangeComplete", () => NProgress.done())
Router.events.on("routeChangeError", () => NProgress.done())

export default function App({ Component, pageProps }) {
  if (pageProps?.pathData) {
    return (
      <AppProvider pathData={pageProps.pathData} context={pageProps.context}>
        <Component {...pageProps} />
        <Analytics />
      </AppProvider>
    )
  }

  return <Component {...pageProps} />
}
